import React from "react";
import axios from "axios";

import theme from "config/theme";

import Slider from "components/Slider";
import Tabs, { Tab } from "components/Tabs";
import { IntroBlock } from "components/Block";
import { Container, Masonry } from "components/Grid";
import Loader from "components/Loader";

import Job from "./Job";
import { Wrapper, Description } from "./styles";

class Jobs extends React.Component {
  state = {
    slide: "all",
    jobs: [],
    departments: [],
    activeDepartment: {},
    isLoading: true
  };

  fetchJobs() {
    const url = `https://boards-api.greenhouse.io/v1/boards/clearmatics/jobs`;

    axios
      .get(url)
      .then(res => {
        this.setState({
          jobs: res.data.jobs,
          isLoading: false
        });
      })
      .catch(error => this.setState({ error, isLoading: false }));
  }

  fetchDepartments() {
    const url = `https://boards-api.greenhouse.io/v1/boards/clearmatics/departments`;

    axios
      .get(url)
      .then(res => {
        const departments = res.data.departments.filter(department => {
          return department.jobs.length > 0;
        });

        this.setState({
          departments: departments
        });
      })
      .catch(error => this.setState({ error, isLoading: false }));
  }

  componentDidMount() {
    this.fetchJobs();
    this.fetchDepartments();
  }

  handleTab = slide => {
    const { departments } = this.state;

    if (slide === "all") {
      this.slider && this.slider.slickGoTo(slide);
      this.setState({
        slide: "all",
        activeDepartment: {}
      });
    } else {
      this.slider && this.slider.slickGoTo(slide + 1);
      this.setState({
        slide: slide + 1,
        activeDepartment: departments[slide]
      });
    }
  };

  render() {
    const {
      slide,
      jobs,
      departments,
      activeDepartment,
      isLoading
    } = this.state;
    const { content } = this.props;

    const breakpoints = {
      default: 3,
      1100: 2,
      700: 1
    };

    const settings = {
      dots: false,
      arrows: false,
      infinite: false,
      adaptiveHeight: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    if (!jobs) {
      return null;
    }

    const activeContentDepartment = content.departments.find(department => {
      return department.name === activeDepartment.name;
    });

    return (
      <Container display="block" pt={["70px", "120px"]}>
        <IntroBlock id="jobs" content={content} />
        {isLoading ? (
          <Loader
            mt="70px"
            mb="50px"
            mx="auto"
            size="100px"
            display="table"
            color={theme.color.primary}
          />
        ) : (
          <>
            <Tabs pt={["10px", "20px"]}>
              <Tab
                active={slide === "all"}
                onClick={() => this.handleTab("all")}
              >
                All Roles
              </Tab>
              {departments.map((department, index) => (
                <Tab
                  key={index}
                  active={slide === index + 1}
                  onClick={() => this.handleTab(index)}
                >
                  {department.name}
                </Tab>
              ))}
            </Tabs>
            <Slider innerRef={ref => (this.slider = ref)} {...settings}>
              <Wrapper>
                {activeContentDepartment &&
                  activeContentDepartment.description && (
                    <Description>
                      {activeContentDepartment.description}
                    </Description>
                  )}
                <Masonry breakpointCols={breakpoints}>
                  {slide === "all"
                    ? jobs.map((job, index) => (
                        <Job content={job} key={index} />
                      ))
                    : activeDepartment.jobs.map((job, index) => (
                        <Job content={job} key={index} />
                      ))}
                </Masonry>
              </Wrapper>
            </Slider>
          </>
        )}
      </Container>
    );
  }
}

export default Jobs;
